function convertToSlug(text: string): string {
  if (text) {
    return text
      .toLowerCase() // Convert to lowercase
      .replace(/®/g, '') // Remove the registered trademark symbol
      .replace(/[^\w\s-]/g, '') // Remove any character that is not a word character, whitespace, or hyphen
      .replace(/\s+/g, '-') // Replace spaces with hyphens
      .replace(/-+/g, '-');
  }
  return '';
}

export const scrollToSection = (id: string, offset: number = 150): boolean => {
  try {
    const element = document.getElementById(id);
    if (element) {
      const topPos =
        element.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({
        top: topPos,
        behavior: 'smooth',
      });
      // Update URL hash if needed
      // history.pushState(null, '', `#${id}`);
      return true;
    }
    return false;
  } catch (error) {
    console.error(`Error scrolling to section ${id}:`, error);
    return false;
  }
};

export { convertToSlug };
